import feathers from "@feathersjs/client";
import auth from "@feathersjs/client/authentication";

const host = process.env.REACT_APP_API_URL || 'http://localhost:3030';
const authOptions = { jwtStrategy: 'jwt', storage: window.localStorage };

export default feathers()
    .configure(feathers.rest(host).fetch(window.fetch.bind(window)))
    .configure(auth(authOptions));



// WEBPACK FOOTER //
// ./src/feathersClient.js